<p>poa-print-options-modal works!</p>
